import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-dongle-provider-dashboard',
  templateUrl: './dongle-provider-dashboard.component.html',
  styleUrls: ['./dongle-provider-dashboard.component.scss']
})
export class DongleProviderDashboardComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
